import { Link } from 'react-router-dom';

export const NotFound = () => (
  <main className="flex min-h-[70vh] flex-col items-center justify-center gap-6 px-6 pt-[72px] text-center" data-testid="not-found-page">
    <img src="/brand/logo.png" alt="CapableBee — AI Voice Assistant" className="h-10 w-auto" />
    <h1 className="text-4xl font-extrabold tracking-tight text-brand-navy">Page not found</h1>
    <p className="max-w-sm text-sm text-slate-600">The page you're looking for doesn't exist or has moved.</p>
    <Link
      to="/"
      data-testid="not-found-home-link"
      className="rounded-full bg-brand-sky px-7 py-3 text-sm font-bold text-white shadow-soft transition-all hover:-translate-y-0.5 hover:bg-brand-skyDeep"
    >
      Back to Home
    </Link>
  </main>
);
